import { graphql } from "@opensea/graphql"
import { CurrencyDescriptionFragment } from "./CurrencyDescription.fragment"

export const CurrencyAboutFragment = graphql(
  `
    fragment CurrencyAbout on Currency {
      description
      ...CurrencyDescription
    }
  `,
  [CurrencyDescriptionFragment],
)
